import React, { createContext, useState, useContext } from 'react';
import { STORAGE_KEYS } from '../constants/storage';

interface OnboardingContextType {
  isOpen: boolean;
  hasSeenOnboarding: boolean;
  openModal: () => void;
  closeModal: () => void;
  resetAndOpen: () => void;
  getHasSeenOnboardingLocal: () => boolean;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export function OnboardingProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasSeenOnboarding, setHasSeenOnboarding] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false);
    setHasSeenOnboarding(true);
    localStorage.setItem(STORAGE_KEYS.HAS_SEEN_ONBOARDING, 'true');
  };
  const resetAndOpen = () => {
    setIsOpen(true);
    setHasSeenOnboarding(true);
    localStorage.setItem(STORAGE_KEYS.HAS_SEEN_ONBOARDING, 'true');
  };

 const getHasSeenOnboardingLocal = () => {
    const hasSeenOnboarding = localStorage.getItem(STORAGE_KEYS.HAS_SEEN_ONBOARDING);
    return hasSeenOnboarding === 'true';
  }; 

  return (
    <OnboardingContext.Provider value={{ isOpen, hasSeenOnboarding, openModal, closeModal, resetAndOpen, getHasSeenOnboardingLocal }}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
} 